const zipUrl = (country, zipCode, locale = 'en') =>
  `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${zipCode}|country:${country}&region=${country}&language=${locale}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

export const getZipCodePlaces = async (country, zipCode) => {
  const response = await fetch(zipUrl(country, zipCode), {
    mode: 'cors'
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  const _data = await response.json();
  return _data.results[0];
};
